import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

export interface ToastMessage {
  id: number;
  severity: ToastSeverity;
  summary: string;
  detail?: string;
  life: number;
  createdAt: number;
}

let nextId = 1;

export const useToastStore = defineStore('toast', () => {
  const messages = ref<ToastMessage[]>([]);

  function add(severity: ToastSeverity, summary: string, detail?: string, life = 5000) {
    const id = nextId++;
    const msg: ToastMessage = {
      id,
      severity,
      summary,
      detail,
      life,
      createdAt: Date.now(),
    };
    messages.value.push(msg);
    if (life > 0) {
      window.setTimeout(() => dismiss(id), life);
    }
    return id;
  }

  function dismiss(id: number) {
    const idx = messages.value.findIndex((m) => m.id === id);
    if (idx >= 0) messages.value.splice(idx, 1);
  }

  return {
    messages,
    add,
    dismiss,
    success: (s: string, d?: string) => add('success', s, d),
    info: (s: string, d?: string) => add('info', s, d),
    warn: (s: string, d?: string) => add('warn', s, d),
    error: (s: string, d?: string) => add('error', s, d, 8000),
  };
});
